'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addAnalyticsDataAttributes } from '../../lib/analytics';
import { useExpansionPanelState } from '../ExpansionPanel';
import { Carat, Minus, Plus, RotateClockwise } from '../Icons';
import { useAccordionSectionContext } from './Section';
import * as Styles from './styles';
import { useAccordionContext } from '.';
const AccordionHeaderIcon = () => {
    const { icon } = useAccordionContext();
    const { disabled } = useAccordionSectionContext();
    const { open } = useExpansionPanelState();
    const plus = open ? _jsx(Minus, { stroke: 'currentColor' }) : _jsx(Plus, { stroke: 'currentColor' });
    const carat = (_jsx(Carat, { stroke: 'currentColor', rotateClockwise: open ? RotateClockwise.Quarter : undefined }));
    const icons = { plus, carat };
    if (disabled)
        return null;
    return _jsx(Styles.HeaderIcon, { children: icons[icon] });
};
export const AccordionHeader = ({ children, className, ...rest }) => {
    const { variant, showBorder, withAnimation } = useAccordionContext();
    const { id, disabled } = useAccordionSectionContext();
    const { open } = useExpansionPanelState();
    return (_jsxs(Styles.Summary, { disabled: disabled, "$showBorder": showBorder, "$variant": variant, "$withAnimation": withAnimation, className: className, ...addAnalyticsDataAttributes({
            category: 'ui-accordion',
            action: open ? 'collapse' : 'expand',
            label: `content-header-${id}`,
        }), ...rest, children: [_jsx(Styles.Header, { children: children }), _jsx(Styles.HeaderControl, { children: _jsx(AccordionHeaderIcon, {}) })] }));
};
//# sourceMappingURL=Header.js.map